module.exports = __webpack_public_path__ + "img/65.a8417810.webp";